// // server.js
// //
// // Use this sample code to handle webhook events in your integration.
// //
// // 1) Paste this code into a new file (server.js)
// //
// // 2) Install dependencies
// //   npm install stripe
// //   npm install express
// //
// // 3) Run the server on http://localhost:4242
// //   node server.js

// // The library needs to be configured with your account's secret key.
// // Ensure the key is kept out of any version control system you might be using.
// const stripe = require("stripe")("sk_test_...");
// const express = require("express");
// const app = express();

// // This is your Stripe CLI webhook secret for testing your endpoint locally.
// const endpointSecret =
//   "whsec_63acfa21aa124e84f72dcddda974e0a690cf9e181b98980bdf40d84f9f33abb5";

// app.post(
//   "/webhook",
//   express.raw({ type: "application/json" }),
//   (request, response) => {
//     const sig = request.headers["stripe-signature"];

//     let event;

//     try {
//       event = stripe.webhooks.constructEvent(request.body, sig, endpointSecret);
//     } catch (err) {
//       response.status(400).send(`Webhook Error: ${err.message}`);
//       return;
//     }

//     // Handle the event
//     switch (event.type) {
//       case "payment_intent.succeeded":
//         const paymentIntentSucceeded = event.data.object;
//         // Then define and call a function to handle the event payment_intent.succeeded
//         break;
//       // ... handle other event types
//       default:
//         console.log(`Unhandled event type ${event.type}`);
//     }

//     // Return a 200 response to acknowledge receipt of the event
//     response.send();
//   }
// );

// app.listen(4242, () => console.log("Running on port 4242"));

import React, { useState } from "react";
import { Button } from "reactstrap";

// import "./App.css";
import StripeCheckout from "react-stripe-checkout";

function Stripe() {
  const [product, setProduct] = useState({
    name: "Standard",
    price: 10,
    productBy: "Lot Ninja",
  });

  const makePayment = (token) => {
    const body = {
      token,
      product,
    };
    const headers = {
      "Content-Type": "application/json",
    };
    return fetch(`http://localhost:8282/payment`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then((response) => {
        console.log("RESPONSE", response);
        const { status } = response;
        console.log("STATUS", status);
      })
      .catch((error) => console.log(error));
  };

  return (
    <div>
      {/* <header className="App-header"> */}
      <StripeCheckout
        stripeKey="pk_test_51N8mQTKK7HItAOBSoHWoChcqP53hzfnbFet65eQ3s7Bb7EDnqzmul6ZC5lieIcgdKNGtNAQsZ1LlxIAMtnxvrnm900dxmTPmsF"
        token={makePayment}
        name="Standard"
        amount={product.price * 100}
      >
        <Button className="button">Reserve</Button>
      </StripeCheckout>
      {/* <StripeCheckout
        stripeKey={process.env.REACT_APP_KEY}
        token={makePayment}
        name="Large"
        amount={product.price * 120}
      >
        <button className="">Large ${product.price * 1.2}</button>
      </StripeCheckout> */}
      {/* </header> */}
    </div>
  );
}

export default Stripe;
